<section id="home-section" class="hero-photo">
    <div class="hero-overlay">
      <div class="hero-grid">
        <div class="hero-content">
          <span class="cw-hero-lockup">🔥 {{ campanaPreview.label }}</span>
          <h1 class="home-title" [innerHTML]="titulo"></h1>
          <p class="home-subtitle"><strong>Descuentos en todos nuestros equipos.</strong><br /><span [innerHTML]="subtitulo"></span></p>
        </div>
        <div class="hero-cards">
          <a
            routerLink="/iphone-nuevos-olavarria"
            class="hero-card"
          >
            <i class="fa-solid fa-mobile-screen-button" aria-hidden="true"></i>
            <span>iPhones Nuevos</span>
          </a>
          <a
            routerLink="/iphone-usados-olavarria"
            class="hero-card"
          >
            <i class="fa-solid fa-clock" aria-hidden="true"></i>
            <span>iPhones Usados</span>
          </a>
          <a [routerLink]="['/cotizar']" class="hero-card">
            <i class="fa-solid fa-arrows-rotate" aria-hidden="true"></i>
            <span>Renovar mi iPhone</span>
          </a>
        </div>
      </div>
    </div>
</section>

<section class="trust-bar">
  <div class="trust-bar-inner">
    <div class="trust-item">
      <i class="fas fa-shield-halved" aria-hidden="true"></i>
      <span>Garantía de 60 días</span>
    </div>
    <div class="trust-item">
      <i class="fas fa-box-open" aria-hidden="true"></i>
      <span>Accesorios incluidos</span>
    </div>
    <div class="trust-item">
      <i class="fas fa-money-check-dollar" aria-hidden="true"></i>
      <span>Hasta 24 cuotas con tarjeta</span>
    </div>
    <div class="trust-item">
      <i class="fas fa-lock" aria-hidden="true"></i>
      <span>Oficina privada en Olavarría</span>
    </div>
  </div>
</section>

<!-- Bloque-respuesta autocontenido: resume el negocio en un párrafo que los
buscadores y motores de IA (ChatGPT, Perplexity, AI Overviews) pueden
extraer tal cual, sin contexto adicional. Si cambia un dato (garantía,
dirección, pagos), actualizarlo también en /llms.txt, en la planilla
"Preguntas Frecuentes" y en el JSON-LD de index.html. -->
<section class="about-section">
  <h2 class="section-title">¿Dónde comprar un iPhone en Olavarría?</h2>
  <p class="about-answer">
    SOY iPhone es una tienda de iPhones nuevos y usados en Olavarría, Buenos
    Aires. Vendemos equipos nuevos sellados y usados revisados, con garantía
    escrita de 60 días para usados y 1 año oficial de Apple para nuevos. Tomamos
    tu iPhone actual como parte de pago (plan canje desde el iPhone 11) y
    ofrecemos envío a domicilio o retiro en San Lorenzo 2586, Oficina 1, con
    cita previa de 9 a 20 hs.
  </p>
  <ul class="about-facts">
    <li>
      <strong>Garantía:</strong> nuevos, 1 año oficial Apple; usados, 60 días.
    </li>
    <li>
      <strong>Formas de pago:</strong> efectivo en dólares o pesos,
      transferencia y USDT sin recargo; tarjeta de crédito hasta 24 cuotas
      fijas.
    </li>
    <li>
      <strong>Plan canje:</strong> tomamos tu iPhone desde el 11 en adelante
      como parte de pago.
    </li>
    <li>
      <strong>Ubicación:</strong> San Lorenzo 2586, Oficina 1, Olavarría, Buenos
      Aires.
    </li>
  </ul>
  <!-- Prueba social con reseñas reales de Google (visibles; no como
  aggregateRating, que Google ignora para LocalBusiness cuando el negocio
  controla sus reseñas). Mientras cargan o si la API falla, bloque estático. -->
  @if (resenas.length) {
    <div class="resenas">
      <div class="resenas-header">
        <img
          class="resenas-foto"
          src="/assets/images/gbp/perfil-144.webp"
          alt="SOY iPhone"
          width="72"
          height="72"
          loading="lazy"
        />
        <p class="resenas-total">
          <strong>{{ (resenasInfo?.promedio || 0).toFixed(1) }} ★</strong> en
          Google · {{ resenasInfo?.total }} reseñas.
          <a
            href="https://maps.app.goo.gl/8izmQtVkVgXHQkmY6"
            target="_blank"
            rel="noopener"
            >Ver todas</a
          >
          ·
          <a
            href="https://search.google.com/local/writereview?placeid=ChIJQbZP-QVFlJURCUmegNenhQs"
            target="_blank"
            rel="noopener"
            >Dejá tu reseña</a
          >
        </p>
      </div>
      <div class="resenas-carrusel-wrap">
        <button
          type="button"
          class="resenas-flecha"
          (click)="scrollPor(-1)"
          aria-label="Reseñas anteriores"
        >
          ‹
        </button>
        <div
          #carrusel
          class="resenas-carrusel"
          (scroll)="alScrollear()"
          (mouseenter)="pausarAuto()"
          (mouseleave)="reanudarAuto()"
          (pointerdown)="iniciarArrastre($event)"
          (pointermove)="moverArrastre($event)"
          (pointerup)="soltarArrastre()"
          (pointerleave)="soltarArrastre()"
        >
          @for (r of resenasLoop; track r) {
            <article class="resena">
              <div
                class="resena-estrellas"
                [attr.aria-label]="r.estrellas + ' de 5'"
              >
                {{ "★★★★★".slice(0, r.estrellas) }}
              </div>
              <p class="resena-texto">“{{ r.comentario }}”</p>
              <p class="resena-autor">— {{ r.autor }}</p>
            </article>
          }
        </div>
        <button
          type="button"
          class="resenas-flecha"
          (click)="scrollPor(1)"
          aria-label="Más reseñas"
        >
          ›
        </button>
      </div>
    </div>
  } @else {
    <p class="about-rating">
      <span class="about-rating-stars" aria-hidden="true">★★★★★</span>
      <span
        ><strong>5.0</strong> en Google · más de 80 reseñas de clientes en
        Olavarría.
        <a
          href="https://maps.app.goo.gl/8izmQtVkVgXHQkmY6"
          target="_blank"
          rel="noopener"
          >Ver reseñas</a
        ></span
      >
    </p>
  }
</section>

<section class="closing-cta-section">
  <h2 class="section-title">¿Listo para tu próximo iPhone?</h2>
  <p class="section-lede">
    Escribinos por WhatsApp y te ayudamos a elegir el equipo ideal, sin
    compromiso.
  </p>
  <div class="closing-cta-buttons">
    <button type="button" (click)="enviarWhatsApp()" class="btn-whatsapp">
      <i class="fab fa-whatsapp" aria-hidden="true"></i>
      Consultar por WhatsApp
    </button>
  </div>
</section>
